import { Policies } from '@/authorization/authorization-policies';
import store from '@/store';
import { invoke, castArray, get } from 'lodash';

const checkRoles = function(roles, checkAll = false) {
	const userRoles = castArray(
		get(store.getters, 'oidcStore/oidcUser.role', [])
	);
	if (checkAll) {
		return !roles.every(role => userRoles.includes(role));
	}
	return !roles.some(role => userRoles.includes(role));
};

const checkPermissions = function(permissions) {
	const userPermissions = castArray(
		get(store.getters, 'oidcStore/oidcUser.SupportPermission', [])
	);
	return !permissions.every(permission =>
		userPermissions.includes(permission)
	);
};

const checkPolicies = function(policies) {
	const policiesCheck =
		policies?.every(policy => invoke(Policies, policy)) ?? true;
	return policiesCheck;
};

export const CheckAllRolesDirective = {
	inserted(el, binding) {
		const roles = binding.value;
		const isDisabled = checkRoles(roles, true);

		if (isDisabled) {
			el.disabled = true;
		}
	}
};

export const CheckSomeRolesDirective = {
	inserted(el, binding) {
		const roles = binding.value;
		const isDisabled = checkRoles(roles);

		if (isDisabled) {
			el.disabled = true;
		}
	}
};

export const CheckPermissionsDirective = {
	inserted(el, binding) {
		const permissions = binding.value;
		const isDisabled = checkPermissions(permissions);

		if (isDisabled) {
			el.disabled = true;
		}
	}
};

export const CheckPoliciesDirective = {
	inserted(el, binding) {
		const policies = binding.value;
		const isDisabled = checkPolicies(policies);

		if (isDisabled) {
			el.disabled = true;
		}
	}
};
